module.exports = __webpack_public_path__ + "img/pc-th.98a450c8.jpg";